import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import ReactSimplyCarousel from 'react-simply-carousel';

import PostAuthors from '~/components/PostCardv3/PostAuthors';
import PostDetails from '~/components/PostCardv3/PostDetails';
import PostImage from '~/components/PostCardv3/PostImage';
import PostPremiumBadge from '~/components/PostCardv3/PostPremiumBadge';
import PostTags from '~/components/PostCardv3/PostTags';
import PostTitles from '~/components/PostCardv3/PostTitles';

import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';

import type { HomePageLoaderData } from '~/routes';

const CarouselHero = () => {
  const { cardStyles, featuredPosts } = useTypedLoaderData<HomePageLoaderData>();

  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  // https://www.npmjs.com/package/react-simply-carousel#usage
  return (
    <div className="relative">
      <ReactSimplyCarousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={1}
        itemsToScroll={1}
        infinite={true}
        forwardBtnProps={{
          className: 'absolute text-white bottom-5 left-36 rounded-full z-10',
          show: true,
          children: <ArrowRightIcon className="h-4 w-4 text-white" />,
        }}
        backwardBtnProps={{
          className: 'absolute text-white bottom-5 left-8 rounded-full z-10',
          show: true,
          children: <ArrowLeftIcon className="h-4 w-4 text-white" />,
        }}
        dotsNav={{
          show: true,
          containerProps: {
            className: 'absolute left-14 bottom-4 w-full space-x-1',
            style: {
              bottom: '18px',
              justifyContent: 'left',
            },
          },
          itemBtnProps: {
            className: 'text-white h-2.5 w-2.5 rounded-full border border-white bg-transparent border-white',
          },
          activeItemBtnProps: {
            className: 'text-white h-2.5 w-2.5 rounded-full border bg-white border-white',
          },
        }}
        responsiveProps={[
          {
            itemsToShow: 1,
            itemsToScroll: 1,
          },
        ]}
        speed={300}
        easing="linear"
      >
        {featuredPosts.map((post) => {
          return (
            <div key={post.id} className="relative h-full w-screen border">
              <PostImage alt={post.web_title} radiusClass={''} hasRadiusApplied={false} src={post.image_url} />

              <div className="absolute bottom-0 w-full p-8 pb-12">
                <div className="flex justify-between">
                  <div className="max-w-md space-y-4">
                    {cardStyles?.tags_enabled && (
                      <PostTags className="relative" tags={post.content_tags} cardStyles={cardStyles} />
                    )}
                    <PostTitles
                      title={{
                        text: post.web_title,
                        fontFamily: cardStyles.heading_font_family,
                        color: '#ffffff',
                      }}
                      subtitle={{
                        text: post?.web_subtitle || '',
                        fontFamily: cardStyles.description_font_family,
                        color: '#ffffff',
                      }}
                    />
                  </div>

                  <div className="flex flex-col items-end justify-end space-y-2">
                    <PostPremiumBadge
                      fontFamily={cardStyles.font}
                      bgColor={cardStyles.premium_bg_color}
                      color={cardStyles.premium_text_color}
                    />
                    <PostAuthors
                      authors={post.authors}
                      color={'#ffffff'}
                      bgColor={cardStyles.bg_color}
                      font={cardStyles.font}
                    />
                    {cardStyles.timefields_enabled && (
                      <PostDetails
                        fontFamily={cardStyles.font}
                        color={'#ffffff'}
                        timestamp={post.override_scheduled_at}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </ReactSimplyCarousel>
    </div>
  );
};

export default CarouselHero;
